function initHHCaptchaOverlay() {
    const overlay = document.getElementById('captcha-overlay');
    if (!overlay) return;
    document.body.style.overflow = 'hidden';

    const input = document.querySelector("#hhcaptcha-input-container input[name='text']");
    const submitBtn = document.getElementById('submit-captcha');
    const errorBox = document.getElementById('captcha-error-container');

    const updateSubmit = () => {
        if (submitBtn && input) submitBtn.disabled = input.value.trim() === '';
    };

    if (input) {
        updateSubmit();
        input.addEventListener('input', () => {
            if (errorBox) errorBox.innerHTML = '';
            updateSubmit();
        });
        input.addEventListener('keydown', e => {
            if (e.key === 'Enter' && submitBtn && !submitBtn.disabled) {
                e.preventDefault();
                submitBtn.click();
            }
        });
    }
}

function refreshCaptcha() {
    const btn = document.getElementById('refresh-captcha');
    if (btn) btn.click();

    const img = document.querySelector('#hhcaptcha-image');
    if (img && img.src) {
        try {
            const url = new URL(img.src, window.location.origin);
            url.searchParams.set('_ts', Date.now().toString());
            img.src = url.toString();
        } catch (_) {
            /* empty */
        }
    }
}

document.addEventListener('click', e => {
    const refreshBtn = e.target.closest('#refresh-captcha');
    if (!refreshBtn) return;

    const errorBox = document.getElementById('captcha-error-container');
    const input = document.querySelector("#hhcaptcha-input-container input[name='text']");
    const submitBtn = document.getElementById('submit-captcha');

    if (errorBox) errorBox.innerHTML = '';
    if (input) input.value = '';
    if (submitBtn) submitBtn.disabled = true;

    refreshCaptcha();
});

function hideCaptchaOverlay() {
    document.body.style.overflow = '';
    const overlay = document.getElementById('captcha-overlay');
    if (overlay) overlay.remove();
    const container = document.getElementById('captcha-container');
    if (container) container.innerHTML = '';
}

document.addEventListener('htmx:afterSwap', e => {
    if (e.target.id !== 'captcha-error-container') return;

    const hasError = e.target.innerHTML.trim() !== '';

    if (hasError) {
        const input = document.querySelector("#hhcaptcha-input-container input[name='text']");
        const submitBtn = document.getElementById('submit-captcha');
        if (input) input.value = '';
        if (submitBtn) submitBtn.disabled = true;

        setTimeout(refreshCaptcha, 500);
    } else {
        const originalSubmit = document.getElementById('submit-button');
        if (originalSubmit) {
            originalSubmit.disabled = false;
            originalSubmit.click();
        } else {
            const addView = document.querySelector('.add_post_view');
            if (addView) addView.click();
        }
        hideCaptchaOverlay();
    }
});

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHHCaptchaOverlay);
} else {
    initHHCaptchaOverlay();
}
